export const hasCompletedInitialLoad = { current: false };
